import React from 'react'
import PropTypes from 'prop-types'
import SquareButton from './squareButton'

import CheckSvg from '../../../assets/icons/check.svg'

const SquareCheckButton = (props) => {
  const { label, onClick } = props
  return (<SquareButton onClick={onClick} icon={CheckSvg} label={label} />)
}

SquareCheckButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func
}

export default SquareCheckButton



// WEBPACK FOOTER //
// ./src/components/buttons/squareButton/squareCheckButton.jsx